<template>
  <b-container class="search">
    <b-row>
      <b-col md="6">
        <div class="search-details">
          <h5>
            Total <span> {{ total }} </span> Journeys
          </h5>
          <span class="svg">
            <svg
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0.195378 5.84553L4.32958 0.389942C4.69754 -0.114356 5.3036 -0.114356 5.67157 0.389942L9.80577 5.84553C10.1737 6.34983 10.0006 6.76243 9.37287 6.76243H0.628278C0.00057265 6.76243 -0.172588 6.34983 0.195378 5.84553ZM9.80577 10.155L5.67157 15.6106C5.3036 16.1149 4.69754 16.1149 4.32958 15.6106L0.195378 10.155C-0.172588 9.65069 0.00057265 9.23808 0.628278 9.23808H9.37287C10.0006 9.23808 10.1737 9.65069 9.80577 10.155Z"
                fill="#8D99A0"
              />
            </svg>
          </span>
          <h6 v-if="lastUpdated">
            Updated at {{ lastUpdated.toDate().toUTCString() }}
          </h6>
        </div>
      </b-col>
      <b-col md="6">
        <b-input-group class="input">
          <b-input-group-prepend>
            <span class="input-group-text"
              ><svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.33334 2.66634C4.75601 2.66634 2.66668 4.75568 2.66668 7.33301C2.66668 9.91034 4.75601 11.9997 7.33334 11.9997C9.91067 11.9997 12 9.91034 12 7.33301C12 4.75568 9.91067 2.66634 7.33334 2.66634ZM1.33334 7.33301C1.33334 4.0193 4.01963 1.33301 7.33334 1.33301C10.6471 1.33301 13.3333 4.0193 13.3333 7.33301C13.3333 10.6467 10.6471 13.333 7.33334 13.333C4.01963 13.333 1.33334 10.6467 1.33334 7.33301Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.6286 10.6289C10.8889 10.3685 11.311 10.3685 11.5714 10.6289L14.4714 13.5289C14.7317 13.7892 14.7317 14.2113 14.4714 14.4717C14.211 14.732 13.7889 14.732 13.5286 14.4717L10.6286 11.5717C10.3682 11.3113 10.3682 10.8892 10.6286 10.6289Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
          </b-input-group-prepend>
          <b-form-input
            class="search-input"
            placeholder="Search Journey"
            v-model="searchStr"
          >
          </b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  props: ["total", "lastUpdated"],
  data() {
    return {
      searchStr: ""
    };
  },
  watch: {
    searchStr(newValue, oldValue) {
      if (newValue.trim() == "") {
        this.$emit("resetSearch");
      } else {
        this.$emit("filterSearch", newValue);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search {
  margin-top: 32px;
  font-family: "Nunito", sans-serif;
  margin-bottom: 24px;
  .input {
    border: none !important;
    margin-left: auto;
    height: 22px;
    width: 200px;
    &:focus,
    &:hover {
      outline: none !important;
      border: none;
      box-shadow: none;
    }

    .search-input {
      border-left: none;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      display: flex;
      align-items: center;
      color: #474d52;
      border: none !important;
      &:focus,
      &:hover {
        outline: none !important;
        border: none;
        box-shadow: none;
      }
      &::placeholder {
        font-size: 16px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #b3c2cb;
      }
    }

    .input-group-text {
      border-right: none;
      background-color: #ffffff;
      border: none !important;
      cursor: pointer;
    }
  }
}
.search-details {
  display: flex;
  // justify-content: ;
  //   align-items: center;
  font-family: "Nunito", sans-serif;
  flex-wrap: wrap;
  h5 {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;
    text-transform: uppercase;
    color: #474d52;
    span {
      font-weight: bold;
      padding: 0px 5px;
    }
    // padding-right: 20px;
  }
  .svg {
    padding: 0px 16px;
    margin-bottom: 11px;
  }
  h6 {
    font-style: italic;
    font-weight: normal;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    color: #8d99a0;
  }
}
@media (max-width: 768px) {
  .search .input {
    margin-left: 0 !important;
    margin-bottom: 15px;
    margin-top: 10px;
  }
}
</style>
